import React from 'react'
import styles from './ScrollRef.module.sass'

interface Props {
  id: string
  offset?: boolean
  className?: string
  refClassName?: string
}

const ScrollRef = (props: Props) => {
  const { id = undefined, offset = true, className = '', refClassName = '' } = props

  return (
    <div className={`${styles.root} ${offset ? styles['root--offset'] : ''} ${className}`}>
      <div id={id} className={`${styles.ref} ${refClassName}`} />
    </div>
  )
}

export default ScrollRef
